import { motion } from "framer-motion";

export default function StatCard({ title, value, icon, trend, trendDirection }) {
    const accentColors = {
      'Total Users': { main: '#3b82f6', bg: 'rgba(59, 130, 246, 0.08)', border: 'rgba(59, 130, 246, 0.15)' },
      'Total Projects': { main: '#10b981', bg: 'rgba(16, 185, 129, 0.08)', border: 'rgba(16, 185, 129, 0.15)' },
      'Professionals': { main: '#a78bfa', bg: 'rgba(167, 139, 250, 0.08)', border: 'rgba(167, 139, 250, 0.15)' },
      'Pending Projects': { main: '#f59e0b', bg: 'rgba(245, 158, 11, 0.08)', border: 'rgba(245, 158, 11, 0.15)' },
    };
    const accent = accentColors[title] || accentColors['Total Users'];

    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        style={{
          padding: '24px',
          background: 'var(--bg-card)',
          border: '1px solid var(--border-glass)',
          borderRadius: '20px',
          position: 'relative',
          overflow: 'hidden',
          transition: 'all 0.3s ease',
        }}
        onMouseEnter={e => {
          e.currentTarget.style.borderColor = accent.border;
          e.currentTarget.style.boxShadow = `0 8px 32px ${accent.bg}`;
        }}
        onMouseLeave={e => {
          e.currentTarget.style.borderColor = 'var(--border-glass)';
          e.currentTarget.style.boxShadow = 'none';
        }}
      >
        {/* Top accent */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '2px',
          background: `linear-gradient(90deg, transparent, ${accent.main}, transparent)`,
          opacity: 0.5,
        }} />

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
          <h3 style={{
            fontSize: '0.8rem',
            fontWeight: 600,
            color: 'var(--text-muted)',
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
          }}>{title}</h3>
          <div style={{
            width: '40px',
            height: '40px',
            borderRadius: '12px',
            background: accent.bg,
            border: `1px solid ${accent.border}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>{icon}</div>
        </div>

        <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
          <p style={{
            fontFamily: 'var(--font-display)',
            fontSize: '2rem',
            fontWeight: 700,
            color: 'var(--text-primary)',
          }}>{value.toLocaleString()}</p>
          {trend && (
            <span style={{
              fontSize: '0.8rem',
              fontWeight: 600,
              color: trendDirection === 'up' ? '#10b981' : '#f87171',
            }}>
              {trend}
            </span>
          )}
        </div>
        <span style={{
          fontSize: '0.7rem',
          color: 'var(--text-muted)',
          marginTop: '4px',
          display: 'block',
        }}>
          {title === "Total Users" && "Total number of users"}
          {title === "Total Projects" && "Total number of projects"}
          {title === "Professionals" && "Total number of professionals"}
          {title === "Pending Projects" && "Projects not yet completed"}
        </span>
      </motion.div>
    )
  }
